import { FileMessage } from "~/components/assistant/messages/FileMessage";
import type { BlobFile } from "~/components/assistant/types";

interface BlobFileMessageProps {
  blobFile: BlobFile;
  debugMode?: boolean;
}

export function BlobFileMessage({ blobFile, debugMode = false }: BlobFileMessageProps) {
  return <FileMessage file={blobFile} artifactType="blob_file" debugMode={debugMode} />;
}
